import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import './Privacy.css';

const Privacy = () => {
  const lastUpdated = 'July 2026';

  return (
    <div className="privacy-page">
      <Helmet>
        <title>Privacy Policy | Al Safa Global</title>
        <meta
          name="description"
          content="Privacy Policy for Al Safa Global General Trading FZ LLC. Learn what information we collect through our enquiry forms, how we use it, and your rights."
        />
        <link rel="canonical" href="https://alsafaglobal.com/privacy" />
      </Helmet>

      <div className="privacy-container">
        <h1 className="privacy-title">Privacy Policy</h1>
        <p className="privacy-updated">Last updated: {lastUpdated}</p>

        <p>
          This Privacy Policy explains how <strong>Al Safa Global General Trading
          FZ LLC</strong> ("Al Safa Global", "we", "us", or "our") handles
          information collected through our website,{' '}
          <a href="https://alsafaglobal.com">alsafaglobal.com</a> (the "Site").
          We are committed to protecting your privacy and handling your
          information responsibly.
        </p>

        <h2>1. Who We Are</h2>
        <p>
          Al Safa Global is a UAE-registered general trading company providing
          procurement and supply chain solutions. Our registered office is
          located at Compass Building, Al Shohada Road, Al Hamra Industrial
          Zone-FZ, Ras Al Khaimah, United Arab Emirates.
        </p>

        <h2>2. Information We Collect</h2>
        <p>
          We only collect personal information that you voluntarily provide when
          you submit an enquiry, quotation request, or event-registration form on
          the Site. This may include:
        </p>
        <ul>
          <li>Full name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>
            Your enquiry details — such as your selected business segment, type of
            inquiry, and any message you choose to send us
          </li>
        </ul>
        <p>
          We <strong>do not</strong> collect passwords, financial or payment
          information, credit card numbers, or identity documents. The Site has no
          public user accounts or logins, does not sell products online, and does
          not process payments.
        </p>

        <h2>3. How We Use Your Information</h2>
        <p>We use the information you provide solely to:</p>
        <ul>
          <li>Respond to your enquiry or quotation request;</li>
          <li>Contact you regarding the products or services you asked about;</li>
          <li>Communicate with you about your business relationship with us.</li>
        </ul>
        <p>
          We do <strong>not</strong> sell, rent, or trade your personal information
          to third parties, and we do not use it for unsolicited marketing.
        </p>

        <h2>4. Cookies and Analytics</h2>
        <p>
          We use a privacy-friendly, cookieless analytics service to understand
          aggregate, anonymous website traffic — such as which pages are visited.
          It does not track you across websites and does not collect personally
          identifiable information.
        </p>

        <h2>5. How We Share Information</h2>
        <p>
          We may share your information only with trusted service providers who help
          us operate the Site and respond to your enquiries (for example, our email
          and hosting providers), and only to the extent necessary. We may also
          disclose information where required to comply with applicable law.
        </p>

        <h2>6. Data Retention</h2>
        <p>
          We retain enquiry information only for as long as necessary to respond to
          your request and maintain our business records, after which it is deleted
          or anonymised.
        </p>

        <h2>7. Data Security</h2>
        <p>
          We take reasonable technical and organisational measures to protect your
          information against unauthorised access, loss, or misuse. However, no
          method of transmission over the internet is completely secure, and we
          cannot guarantee absolute security.
        </p>

        <h2>8. Your Rights</h2>
        <p>
          You may request access to, correction of, or deletion of the personal
          information you have submitted to us. To make such a request, please
          contact us using the details below.
        </p>

        <h2>9. Children's Privacy</h2>
        <p>
          The Site is intended for business use and is not directed to children. We
          do not knowingly collect personal information from children.
        </p>

        <h2>10. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be
          posted on this page with an updated "Last updated" date.
        </p>

        <h2>11. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us:
        </p>
        <ul>
          <li>Email: <a href="mailto:info@alsafaglobal.com">info@alsafaglobal.com</a></li>
          <li>Phone: <a href="tel:0097143741969">00971 4 3741 969</a></li>
          <li>
            Address: Compass Building, Al Shohada Road, Al Hamra Industrial Zone-FZ,
            Ras Al Khaimah, UAE
          </li>
        </ul>

        <p className="privacy-back">
          <Link to="/">← Back to home</Link>
        </p>
      </div>
    </div>
  );
};

export default Privacy;
